import React from 'react';
import { Box } from '@mui/material';
import { diffLines } from 'diff';

export default function DiffContext({ beforeContent, afterContent, issueLines = [] }) {
  const stripFences = (s) => {
    if (!s) return '';
    let t = s.trim();
    if (t.startsWith('```')) { const nl = t.indexOf('\n'); t = nl !== -1 ? t.slice(nl + 1) : t.replace(/^```/, ''); }
    if (t.endsWith('```')) t = t.slice(0, -3);
    return t.trim();
  };
  const oldText = stripFences(beforeContent || '');
  const newText = stripFences(afterContent || '');
  const parts = diffLines(oldText, newText);
  let renderWithLineNumbers = Array.isArray(issueLines) && issueLines.length > 0;
  let oldLineNum = 1;
  let newLineNum = 1;
  return (
    <Box sx={{ mt: 2, border: '1px solid #30363d', borderRadius: '6px' }}>
      {parts.map((part, idx) => {
        const isAdd = !!part.added; const isRem = !!part.removed; const lines = (part.value || '').toString().split('\n');
        if (!renderWithLineNumbers) {
          const bg = isAdd ? '#102a17' : isRem ? '#3d2e00' : '#0d1117';
          const color = isAdd ? '#7ee787' : isRem ? '#ffa657' : '#f0f6fc';
          const borderLeft = isAdd ? '#238636' : isRem ? '#f0883e' : '#30363d';
          return (
            <Box key={idx} sx={{ backgroundColor: bg, color, borderLeft: `4px solid ${borderLeft}` }}>
              <pre style={{ margin: 0, whiteSpace: 'pre-wrap', padding: '6px 12px', fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace', fontSize: 12 }}>{part.value}</pre>
            </Box>
          );
        }
        return (
          <Box key={idx} sx={{ borderLeft: `4px solid ${isAdd ? '#238636' : isRem ? '#da3633' : '#30363d'}`, backgroundColor: isAdd ? '#102a17' : isRem ? '#3b0a10' : '#0d1117', color: '#f0f6fc' }}>
            {lines.map((line, i) => {
              let markOrange = false;
              if (isAdd) { markOrange = false; newLineNum += 1; }
              else if (isRem) { markOrange = true; oldLineNum += 1; }
              else { markOrange = issueLines.includes(oldLineNum); oldLineNum += 1; newLineNum += 1; }
              const bg = markOrange ? '#3d2e00' : (isAdd ? '#102a17' : isRem ? '#3b0a10' : '#0d1117');
              const color = markOrange ? '#ffa657' : (isAdd ? '#7ee787' : isRem ? '#ff7b72' : '#f0f6fc');
              const pad = '6px 12px';
              return (<pre key={i} style={{ margin: 0, whiteSpace: 'pre-wrap', padding: pad, backgroundColor: bg, color, fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace', fontSize: 12 }}>{line}</pre>);
            })}
          </Box>
        );
      })}
    </Box>
  );
}




